import { STORAGE } from "@/shared/utils/storage";

/*
  Carries an invitation across an account being created.

  An invitee without an account clicks "Sign in to accept", creates the account at the
  provider, and confirms the address from an email. The provider does not return to the
  sign-in that started this (and notitia's own pending sign-in has expired by then), so the
  person ends up signed in somewhere else. The invitation's address is kept on this device
  instead, and the next sign-in here opens it once. Another browser or device does not see it;
  the link in the invitation email still works there.
*/

/** Long enough to create and confirm an account; short of the invitation's own week. */
export const PENDING_INVITATION_TTL_MS = 24 * 60 * 60 * 1000;

/** Keeps `path` (`/invitations/<token>`) for the next sign-in in this browser. */
export function rememberInvitation(path: string, now = Date.now()): void {
	STORAGE.pendingInvitation.write({ path, savedAt: now });
}

export function forgetInvitation(): void {
	STORAGE.pendingInvitation.clear();
}

/** The kept invitation's path, removed as it is taken; `null` when there is none or it is stale. */
export function takePendingInvitation(now = Date.now()): string | null {
	const pending = STORAGE.pendingInvitation.read();
	forgetInvitation();
	if (!pending || now - pending.savedAt > PENDING_INVITATION_TTL_MS) return null;
	return pending.path;
}
